<template>
	<div class="body">
		<div class="close-btn" v-on:click="close">
			<i title="close" class="material-icons md-18">close</i>
		</div>
		<div class="title">REMOVE SELECTED PARCELS</div>
		<div class="p-3">
			<form class="category form-group" v-on:submit.prevent="formSubmit">
				<div class="modal-property-row">
					Are you sure you would like to remove {{theseParcelsDisplay}}?
				</div>
				<div class="modal-actions">
					<button class="btn btn-dark float-right" type="submit">Remove</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>

export default {
	name:'collectionRemove',
	props: {
		selected:{
			type:Array,
		},
	},
	computed:{
		planActive:function(){
			return this.$store.state.plan.active;
		},
		theseParcelsDisplay:function(){
			if (this.selected.length < 2) return `this ${this.selected.length} parcel`;
			return `these ${this.selected.length} parcels`;
		}
	},
	data: function(){
		return {
			error:null,
			loading: true,
			loadError: null,
		}
	},
	methods:{
		close:function(){
			this.$emit('close');
		},
		formSubmit:async function(){
			try {
				this.loadError = null;
				this.loading = true;
				const parcelIds = this.selected.map(parcel => {
					return parcel.id
				});
				await this.$store.dispatch('COLLECTION_PARCELS_REMOVE', {collectionId:this.$route.params.collectionId, parcelIds});
				this.loading = false;
				this.$emit('parcelsRemoved');
				this.close();
			} catch(e){
				this.loadError = e;		
			}
		},
		numSelected:function(){

		}
	}
};

</script>


// WEBPACK FOOTER //
// src/components/collection/collection-remove-selected.vue